var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMockInterviewIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5039 0.304688C10.7691 0.304688 11.0235 0.410044 11.211 0.597581C11.3985 0.785117 11.5039 1.03947 11.5039 1.30469V6.30469C11.5039 6.85969 11.0589 7.30469 10.5039 7.30469H12.5039V8.30469H0.503906V7.30469H2.50391C2.23869 7.30469 1.98434 7.19933 1.7968 7.0118C1.60926 6.82426 1.50391 6.5699 1.50391 6.30469V1.30469C1.50391 0.749688 1.94891 0.304688 2.50391 0.304688H10.5039ZM10.5039 1.30469H2.50391V6.30469H10.5039V1.30469ZM6.50391 4.30469C7.60891 4.30469 8.50391 4.75469 8.50391 5.30469V5.80469H4.50391V5.30469C4.50391 4.75469 5.39891 4.30469 6.50391 4.30469ZM6.50391 1.80469C6.76912 1.80469 7.02348 1.91004 7.21101 2.09758C7.39855 2.28512 7.50391 2.53947 7.50391 2.80469C7.50391 3.0699 7.39855 3.32426 7.21101 3.51179C7.02348 3.69933 6.76912 3.80469 6.50391 3.80469C5.94891 3.80469 5.50391 3.35969 5.50391 2.80469C5.50391 2.24969 5.95391 1.80469 6.50391 1.80469Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMockInterviewIcon);
export default __webpack_public_path__ + "static/media/mockInterviewIcon.ed9f1bea880d0e5e82de9344b7b53cff.svg";
export { ForwardRef as ReactComponent };